import react, { useState, useEffect } from "react";
import { useGetReportSurveyDigitalAgricultureQuery } from "./RiskManagementApiSlice";
import { Table } from "reactstrap";
import { Button } from "antd";
import swal from "sweetalert";

const DigitalAgricultureFileResponse = ({ formName }) => {
  const { data: getResponse } = useGetReportSurveyDigitalAgricultureQuery(
    formName
  );
  const handleDownload = (fileUrl, Status) => {
    const a = document.createElement("a");
    // a.href = start + "/" + end + " date";
    // a.download = start + "/" + end + " date";
    if (fileUrl === null) {
      swal("Please wait, your request is being processed.", {
        buttons: false,
        icon: "warning",
        title: Status,
        timer: 7500,
        showCloseButton: true,
        cancelButtonText: "Close",
      });
      return;
    }
    a.href = fileUrl;
    a.download = fileUrl.split("/").pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date
      .getHours()
      .toString()
      .padStart(2, "0");
    const minutes = date
      .getMinutes()
      .toString()
      .padStart(2, "0");
    const seconds = date
      .getSeconds()
      .toString()
      .padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };
  return (
    <div className="backgroundColorBeigeHealth">
      <Table striped hover className="">
        <thead>
          <tr>
            <th className="th-sm">Start Date </th>
            <th className="th-sm">End Date</th>
            <th className="th-sm">Report Creation Date</th>
            <th className="th-sm">Report Creation Time</th>
            <th className="th-sm">Created By</th>
            <th className="th-sm">Document Included</th>
            <th className="th-sm">Status</th>
            <th className="th-sm">File</th>
          </tr>
        </thead>
        <tbody>
          {getResponse?.data?.results?.map((field, index) => (
            <tr key={index}>
              <td>{field.StartDate}</td>
              <td>{field.EndDate}</td>
              <td className="">{field.CreatedOn.slice(0, 10)}</td>
              <td className="">{formatTime(field.CreatedOn)}</td>
              <td>{field.CreatedName}</td>
              <td>{field.Flag ? "Yes" : "No"}</td>
              <th
                className={`${
                  field.Status === "Pending"
                    ? "text-warning th-sm"
                    : "text-success th-sm"
                }`}
              >
                {field.Status}
              </th>

              <td>
                <Button size="small">
                  <span
                    className="mdi mdi-download cursor-pointer text-warning"
                    onClick={() => handleDownload(field.FileName, field.Status)}
                  ></span>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
export default DigitalAgricultureFileResponse;
